/**
 * Vendor entity index page
 */

import { EntityIndex } from './base';
import { canonicalPath } from '@electinfo/common';
import { matchLeafDetailPath } from './leaf-detail';
import { loadVendorDetail } from './leaf-profiles';
import type { EntityConfig, EntitySearchResult } from './types';

function formatCurrency(amount: number): string {
  if (amount >= 1_000_000_000) {
    return `$${(amount / 1_000_000_000).toFixed(1)}B`;
  } else if (amount >= 1_000_000) {
    return `$${(amount / 1_000_000).toFixed(1)}M`;
  } else if (amount >= 1_000) {
    return `$${(amount / 1_000).toFixed(0)}K`;
  }
  return `$${amount.toLocaleString()}`;
}

class VendorIndex extends EntityIndex {
  protected setup(): void {
    const detailId = matchLeafDetailPath('vendors');
    if (detailId) {
      void loadVendorDetail(detailId);
      return;
    }
    super.setup();
  }

  getConfig(): EntityConfig {
    return {
      entityType: 'Vendor',
      placeholder: 'Search vendors by name...',
      browseTitle: 'All Vendors',
      sortField: 'total_received',
      sortOrder: 'DESC',
      formatResult: (result: EntitySearchResult) => {
        const city = result.city || '';
        const state = result.state || '';
        const location = [city, state].filter(Boolean).join(', ');
        const totalReceived = result.score ? formatCurrency(result.score) : '';
        const metaParts = [location, totalReceived ? `${totalReceived} received` : ''].filter(Boolean);
        return {
          url: `/${canonicalPath('Vendor', result.id)}/`,
          name: result.name || '',
          meta: metaParts.join(' - ') || 'Campaign Vendor'
        };
      }
    };
  }
}

new VendorIndex();
